export default __webpack_public_path__ + "static/media/upload.218db45c.svg";